export function useAuth() {
  const api = useAxios();
  const login = async (data: any) => await api.$post('/login', data);
  return {
    login,
  };
}
